module.exports = __webpack_public_path__ + "img/iphone-qrcode-overlay-tuto.2d05656b.webp";